import * as React from 'react';
import { cn } from '../../lib/utils';

type TagTone = 'neutral' | 'accent' | 'amber' | 'violet' | 'sky' | 'rose';

interface TagProps {
  tone?: TagTone;
  children: React.ReactNode;
  className?: string;
}

const TONES: Record<TagTone, string> = {
  neutral: 'bg-line/60 text-muted',
  accent: 'bg-accent-soft text-accent',
  amber: 'bg-amber-soft text-amber',
  violet: 'bg-violet-soft text-violet',
  sky: 'bg-sky-soft text-sky',
  rose: 'bg-rose-soft text-rose',
};

export const Tag = ({ tone = 'neutral', children, className }: TagProps) => (
  <span
    className={cn(
      'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wide',
      TONES[tone],
      className
    )}
  >
    {children}
  </span>
);
